import styled from 'styled-components';
import { cssVar } from 'src/app/styles/helper';
import Stack from '../Layout/Stack/Stack';
interface SliderProgressProps {
  $value: number;
}

interface SliderThumbProps {
  $value: number;
}

export const StackContainer = styled(Stack)`
  width: 100%;
`;

export const SliderContainer = styled.div`
  width: 100%;
  position: relative;
  height: 32px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export const SliderTrack = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${cssVar('bg-quaternary')};
  border-radius: ${cssVar('radius-sm')};
  position: relative;
`;

export const SliderProgress = styled.div<SliderProgressProps>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${({ $value }) => `${$value}%`};
  background-color: ${cssVar('fg-brand-primary')};
  border-radius: ${cssVar('radius-sm')};
`;

export const SliderThumb = styled.div<SliderThumbProps>`
  position: absolute;
  left: ${({ $value }) => `${$value}%`};
  top: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  background-color: ${cssVar('bg-primary')};
  border: 2px solid ${cssVar('border-brand-alt')};
  border-radius: ${cssVar('radius-circle')};
  cursor: pointer;
  transition: transform 0.1s ease;

  &:hover {
    transform: translate(-50%, -50%) scale(1.1);
  }

  &:active {
    transform: translate(-50%, -50%) scale(0.95);
  }
`;

export const SliderInputContainer = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
`;
